import { FC } from 'react';
import { Box, DialogContent, ModalProps } from '@mui/material';

import { MainButton } from '../MainButton';

import { PAYMENT_STEP } from '~common';
import { FullHeightSlideDialog } from '~components/atoms/custom';
import { LocalizationTypography } from '~components/organisms/localization';
import { stationStatusMessages } from '~components/pages/bad-status/constants';
import { usePaymentStepContext } from '~providers';
import { StationStatus } from '~types/station.type';

interface PreAuthFailedDialogProps {
  open: boolean;
  onClose: ModalProps['onClose'];
}

export const PreAuthFailedDialog: FC<PreAuthFailedDialogProps> = ({
  open,
  onClose,
}) => {
  const { handleSetPaymentStep } = usePaymentStepContext();
  const preAuthFailedMessage =
    stationStatusMessages[StationStatus.PRE_AUTH_FAILED];
  const PreAuthFailedImage = preAuthFailedMessage?.img;

  return (
    <FullHeightSlideDialog $height={170} open={open} onClose={onClose}>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={2}
        >
          {PreAuthFailedImage && <PreAuthFailedImage />}

          <LocalizationTypography
            sx={{ mt: 1.5 }}
            variant="Poppins/Heading-3"
            textId={preAuthFailedMessage.localeTextId}
            defaultText={preAuthFailedMessage.title}
          />

          <LocalizationTypography
            textAlign="center"
            variant="Inter/Body-md"
            color="#6B7280"
            textId="app.badStatusStationPage.text.guidingPreAuthFailed"
            defaultText="Your rental couldn’t start due to a payment issue. Please update your card and try again."
          />

          <MainButton
            fullWidth
            variant="contained"
            color="primary"
            onClick={() =>
              handleSetPaymentStep(PAYMENT_STEP.SELECT_PAYMENT_METHOD)
            }
          >
            <LocalizationTypography
              variant="Poppins/Subheading-md"
              textId="app.rentalPage.newStepThree.rentCharger.changePaymentMethod"
              defaultText="Change Payment Method"
            />
          </MainButton>

          <MainButton
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => onClose?.({}, 'escapeKeyDown')}
          >
            <LocalizationTypography
              variant="Poppins/Subheading-md"
              textId="app.rentalPage.newStepThree.rentCharger.backToCheckout"
              defaultText="Back to Checkout"
            />
          </MainButton>
        </Box>
      </DialogContent>
    </FullHeightSlideDialog>
  );
};
